import { render, staticRenderFns } from "./ApplicantRepLegalIds.vue?vue&type=template&id=a04fa8a6&"
import script from "./ApplicantRepLegalIds.vue?vue&type=script&lang=js&"
export * from "./ApplicantRepLegalIds.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantRepLegalIds.vue?vue&type=style&index=0&id=a04fa8a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports